import { Action } from '@ngrx/store';
import {
  CustomEndPointValidationRequest,
  CustomerBasic,
  CustomerDetail,
  CustomerForm,
  CustomerLoyaltyProfile,
  CustomerLoyaltyProfileUpdateData,
  CustomerLoyaltyTrasaction,
  CustomerOrderItem,
  CustomerOrderItems,
  CustomerOrderSummary,
  CustomerReservation,
  CustomerReservationStatistics,
  OrderItem,
  SaveZonePositionView,
  WoltLoginRequest,
  Product,
  ProductListResponse,
  ProductResponse,
} from './../stores';

import {
  ClientStore,
  ClientStoreRequest,
  Customer,
  MynextLoginResponse,
  PowersoftLoginRequest,
  StoreOrderItemsStatistics,
  StoreRelationRequest,
  StoreSearchCriteria,
  StoreStatistics,
  StoreZone,
  StoreZoneStatus,
  User,
} from '../stores';

import { Page } from 'src/app/api/types/Page';
import { PageableResults, Paging } from 'src/app/api/types/Pageable';
import { HideLoader, ShowLoader } from 'src/app/shared/decorators';
import { NotificationSubscriptions } from 'src/app/shared/notifications';
import { AddBookingTierRequest } from '../events/event-models/AddBookingTierRequest';
import { ClientStoreOrder } from '../store-order/store-order';
import { CustomerType } from '../customer-search.model';
import { AliasAvailabilityStatus, TabUserExperience } from './stores.reducer';
import { IntegrationProvider } from 'src/app/public/store/types/IntegrationPayment';

export enum StoresActionType {
  InitializeState = '[stores] InitializeState',
  LoadStores = '[stores] LoadStores',
  LoadStoresPage = '[stores] LoadStoresPage',
  LoadStoresSuccess = '[stores] LoadStoresSuccess',
  LoadStoresFailed = '[stores] LoadStoresFailed',
  LoadStore = '[stores] LoadStore',
  LoadStoreSuccess = '[stores] LoadStoreSuccess',
  LoadStoreFailed = '[stores] LoadStoreFailed',
  CreateStore = '[stores] CreateStore',
  CreateStoreSuccess = '[stores] CreateStoreSuccess',
  CreateStoreFailed = '[stores] CreateStoreFailed',
  PartialUpdateStore = '[stores] PartialUpdateStore',
  PartialUpdateStoreSuccess = '[stores] PartialUpdateStoreSuccess',
  PartialUpdateStoreFailed = '[stores] PartialUpdateStoreFailed',
  DeleteStore = '[stores] DeleteStore',
  DeleteStoreSuccess = '[stores] DeleteStoreSuccess',
  DeleteStoreFailed = '[stores] DeleteStoreFailed',
  DeleteStoreParent = '[stores] DeleteStoreParent',
  DeleteStoreParentSuccess = '[stores] DeleteStoreParentSuccess',
  DeleteStoreParentFailed = '[stores] DeleteStoreParentFailed',
  UpdateStore = '[stores] UpdateStore',
  UpdateStoreSuccess = '[stores] UpdateStoreSuccess',
  UpdateStoreFailed = '[stores] UpdateStoreFailed',
  UpdateStoreVatPercentage = '[stores] UpdateStoreVatPercentage',
  UpdateStoreVatPercentageSuccess = '[stores] UpdateStoreVatPercentageSuccess',
  UpdateStoreVatPercentageFailed = '[stores] UpdateStoreVatPercentageFailed',
  UpdateStoreSettings = '[stores] UpdateStoreSettings',
  UpdateStoreSettingsSuccess = '[stores] UpdateStoreSettingsSuccess',
  UpdateStoreSettingsFailed = '[stores] UpdateStoreSettingsFailed',
  DownloadQRImage = '[stores] DownloadQRImage',
  DownloadQRImageSuccess = '[stores] DownloadQRImageSuccess',
  DownloadQRImageFailed = '[stores] DownloadQRImageFailed',
  DownloadQRPdf = '[stores] DownloadQRPdf',
  DownloadQRPdfSuccess = '[stores] DownloadQRPdfSuccess',
  DownloadQRPdfFailed = '[stores] DownloadQRPdfFailed',
  DownloadQRImages = '[stores] DownloadQRImages',
  DownloadQRImagesSuccess = '[stores] DownloadQRImagesSuccess',
  DownloadQRImagesFailed = '[stores] DownloadQRImagesFailed',
  DownloadQRFullPdf = '[stores] DownloadQRFullPdf',
  DownloadQRFullPdfSuccess = '[stores] DownloadQRFullPdfSuccess',
  DownloadQRFullPdfFailed = '[stores] DownloadQRFullPdfFailed',
  LoadUsers = '[stores] LoadUsers',
  LoadUsersPage = '[stores] LoadUsersPage',
  LoadUsersSuccess = '[stores] LoadUsersSuccess',
  LoadUsersFailed = '[stores] LoadUsersFailed',
  ChangeAccountManager = '[stores] ChangeAccountManager',
  ChangeAccountManagerSuccess = '[stores] ChangeAccountManagerSuccess',
  ChangeAccountManagerFailed = '[stores] ChangeAccountManagerFailed',
  LoadOrderItemsStatisticsPage = '[stores] LoadOrderItemsStatisticsPage',
  LoadOrderItemsStatisticsSuccess = '[stores] LoadOrderItemsStatisticsSuccess',
  LoadOrderItemsStatisticsFailed = '[stores] LoadOrderItemsStatisticsFailed',
  InviteUser = '[stores] InviteUser',
  InviteUserSuccess = '[stores] InviteUserSuccess',
  InviteUserFailed = '[stores] InviteUserFailed',
  RemoveUserStoreAccess = '[stores] RemoveUserStoreAccess',
  RemoveUserStoreAccessSuccess = '[stores] RemoveUserStoreAccessSuccess',
  RemoveUserStoreAccessFailed = '[stores] RemoveUserStoreAccessFailed',
  UploadStoreImage = '[stores] UploadStoreImage',
  UploadStoreImageSuccess = '[stores] UploadStoreImageSuccess',
  UploadStoreImageFailed = '[stores] UploadStoreImageFailed',
  UploadStoreLogo = '[stores] UploadStoreLogo',
  UploadStoreLogoSuccess = '[stores] UploadStoreLogoSuccess',
  UploadStoreLogoFailed = '[stores] UploadStoreLogoFailed',
  SearchStores = '[stores] SearchStores',
  SearchStoresFailed = '[stores] SearchStoresFailed',
  SearchStoresSuccess = '[stores] SearchStoresSuccess',
  LoadStoreStatistics = '[stores] LoadStoreStatistics',
  LoadStoreStatisticsFailed = '[stores] LoadStoreStatisticsFailed',
  LoadStoreStatisticsSuccess = '[stores] LoadStoreStatisticsSuccess',
  LoadMenuViewingStatistics = '[stores] LoadMenuViewingStatistics',
  LoadMenuViewingStatisticsFailed = '[stores] LoadMenuViewingStatisticsFailed',
  LoadMenuViewingStatisticsSuccess = '[stores] LoadMenuViewingStatisticsSuccess',
  LoadLoyaltyStatistics = '[stores] LoadLoyaltyStatistics',
  LoadLoyaltyStatisticsFailed = '[stores] LoadLoyaltyStatisticsFailed',
  LoadLoyaltyStatisticsSuccess = '[stores] LoadLoyaltyStatisticsSuccess',
  ClearLoyaltyStatistics = '[stores] ClearLoyaltyStatistics',
  ValidateAliasAvailability = '[stores] ValidateAliasAvailability',
  ValidateAliasAvailabilitySuccess = '[stores] ValidateAliasAvailabilitySuccess',
  ValidateAliasAvailabilityFailed = '[stores] ValidateAliasAvailabilityFailed',
  ValidateAliasAvailabilityReset = '[stores] ValidateAliasAvailabilityReset',
  LoadNotificationSubscriptionStatus = '[stores] LoadNotificationSubscriptionStatus',
  LoadNotificationSubscriptionStatusSuccess = '[stores] LoadNotificationSubscriptionStatusSuccess',
  LoadNotificationSubscriptionStatusFailed = '[stores] LoadNotificationSubscriptionStatusFailed',
  RequestNotificationPermission = '[stores] RequestNotificationPermission',
  ToggleNotificationSubscriptionStatus = '[stores] ToggleNotificationSubscriptionStatus',
  ToggleNotificationSubscriptionStatusSuccess = '[stores] ToggleNotificationSubscriptionStatusSuccess',
  ToggleNotificationPermitted = '[stores] ToggleNotificationPermitted',
  UpdateNotificationSubscriptions = '[stores] UpdateNotificationSubscriptions',
  LoadAutoprintSubscriptionStatus = '[stores] LoadAutoprintSubscriptionStatus',
  LoadAutoprintSubscriptionStatusSuccess = '[stores] LoadAutoprintSubscriptionStatusSuccess',
  LoadAutoprintSubscriptionStatusFailed = '[stores] LoadAutoprintSubscriptionStatusFailed',
  RequestAutoprintPermission = '[stores] RequestAutoprintPermission',
  ToggleAutoprintSubscriptionStatus = '[stores] ToggleAutoprintSubscriptionStatus',
  ToggleAutoprintSubscriptionStatusSuccess = '[stores] ToggleAutoprintSubscriptionStatusSuccess',
  ToggleAutoprintPermitted = '[stores] ToggleAutoprintPermitted',
  CreateOrUpdateZone = '[stores] CreateOrUpdateZone',
  CreateOrUpdateZoneSuccess = '[stores] CreateOrUpdateZoneSuccess',
  CreateOrUpdateZoneFailed = '[stores] CreateOrUpdateZoneFailed',
  GetStatusOfZone = '[stores] GetStatusOfZone',
  GetStatusOfZoneSuccess = '[stores] GetStatusOfZoneSuccess',
  GetStatusOfZoneFailed = '[stores] GetStatusOfZoneFailed',
  LoadZones = '[stores] LoadZones',
  LoadZonesFailed = '[stores] LoadZonesFailed',
  LoadZonesSuccess = '[stores] LoadZonesSuccess',
  LoadZone = '[stores] LoadZone',
  LoadZoneFailed = '[stores] LoadZoneFailed',
  LoadZoneSuccess = '[stores] LoadZoneSuccess',
  RemoveZone = '[stores] RemoveZone',
  RemoveZoneSuccess = '[stores] RemoveZoneSuccess',
  RemoveZoneFailed = '[stores] RemoveZoneFailed',
  RemoveStoreLogo = '[stores] RemoveStoreLogo',
  RemoveStoreLogoSuccess = '[stores] RemoveStoreLogoSuccess',
  RemoveStoreLogoFailed = '[stores] RemoveStoreLogoFailed',
  RemoveStoreImage = '[stores] RemoveStoreImage',
  RemoveStoreImageSuccess = '[stores] RemoveStoreImageSuccess',
  RemoveStoreImageFailed = '[stores] RemoveStoreImageFailed',
  RemoveStoreHeaderVideo = '[stores] RemoveStoreHeaderVideo',
  RemoveStoreHeaderVideoSuccess = '[stores] RemoveStoreHeaderVideoSuccess',
  RemoveStoreHeaderVideoFailed = '[stores] RemoveStoreHeaderVideoFailed',
  CheckStoreHasNewOrder = '[stores] CheckStoreHasNewOrder',
  CheckStoreHasNewOrderSuccess = '[stores] CheckStoreHasNewOrderSuccess',
  CheckStoreHasNewOrderFailed = '[stores] CheckStoreHasNewOrderFailed',
  StartOrderNotificationSound = '[stores] StartOrderNotificationSound',
  DownloadOrderItemsXls = '[stores] DownloadOrderItemsXls',
  DownloadOrderItemsXlsSuccess = '[stores] DownloadOrderItemsXlsSuccess',
  DownloadOrderItemsXlsFailed = '[stores] DownloadOrderItemsXlsFailed',
  InitializeStoreUserExperience = '[stores] InitializeStoreUserExperience',
  UpdateStoreTabUserExperience = '[stores] UpdateStoreTabUserExperience',
  UpdateStoreTab = '[stores] UpdateStoreTab',
  UpdateStoreZoneSettings = '[stores] UpdateStoreZoneSettings',
  UpdateStoreZoneSettingsSuccess = '[stores] UpdateStoreZoneSettingsSuccess',
  UpdateStoreZoneSettingsFailed = '[stores] UpdateStoreZoneSettingsFailed',
  ClearStoreValidation = '[stores] ClearStoreValidation',
  MynextLogin = '[stores] MynextLogin',
  MynextLoginSuccess = '[stores] MynextLoginSuccess',
  MynextLoginFailed = '[stores] MynextLoginFailed',
  HubriseLogin = '[stores] HubriseLogin',
  HubriseLoginSuccess = '[stores] HubriseLoginSuccess',
  HubriseLoginFailed = '[stores] HubriseLoginFailed',
  HubriseLogout = '[stores] HubriseLogout',
  HubriseLogoutSuccess = '[stores] HubriseLogoutSuccess',
  HubriseLogoutFailed = '[stores] HubriseLogoutFailed',
  ClearHubriseData = '[stores] ClearHubriseData',
  LoadCustomersPage = '[customers] LoadCustomersPage',
  LoadCustomersSuccess = '[customers] LoadCustomersSuccess',
  LoadCustomersFailed = '[customers] LoadCustomersFailed',
  TopOrderCustomersPage = '[customers] TopOrderCustomersPage',
  TopOrderCustomersSuccess = '[customers] TopOrderCustomersSuccess',
  TopOrderCustomersFailed = '[customers] TopOrderCustomersFailed',
  TopReservationCustomersPage = '[customers] TopReservationCustomersPage',
  TopReservationCustomersSuccess = '[customers] TopReservationCustomersSuccess',
  TopReservationCustomersFailed = '[customers] TopReservationCustomersFailed',
  DownloadCustomersList = '[customers] DownloadCustomersList',
  DownloadCustomersListSuccess = '[customers] DownloadCustomersListSuccess',
  DownloadCustomersListFailed = '[customers] DownloadCustomersListFailed',
  DownloadFlyerFile = '[stores] DownloadFlyerFile',
  DownloadFlyerFileSuccess = '[stores] DownloadFlyerFileSuccess',
  DownloadFlyerFileFailed = '[stores] DownloadFlyerFileFailed',
  PowersoftLogin = '[stores] PowersoftLogin',
  PowersoftLoginSuccess = '[stores] PowersoftLoginSuccess',
  PowersoftLoginFailed = '[stores] PowersoftLoginFailed',
  DisconnectPowersoftFailed = '[stores] DisconnectPowersoftFailed',
  DisconnectPowersoftSuccess = '[stores] DisconnectPowersoftSuccess',
  DisconnectPowersoft = '[stores] DisconnectPowersoft',
  SynchronizePowersoftCatalog = '[stores] SynchronizePowersoftCatalog',
  SynchronizePowersoftCatalogSuccess = '[stores] SynchronizePowersoftCatalogSuccess',
  SynchronizePowersoftCatalogFailed = '[stores] SynchronizePowersoftCatalogFailed',

  WoltLogin = '[stores] WoltLogin',
  WoltLoginSuccess = '[stores] WoltLoginSuccess',
  WoltLoginFailed = '[stores] WoltLoginFailed',
  DisconnectWoltFailed = '[stores] DisconnectWoltFailed',
  DisconnectWoltSuccess = '[stores] DisconnectWoltSuccess',
  DisconnectWolt = '[stores] DisconnectWolt',

  DisconnectMyNext = '[stores] DisconnectMyNext',
  DisconnectMyNextSuccess = '[stores] DisconnectMyNextSuccess',
  DisconnectMyNextFailed = '[stores] DisconnectMyNextFailed',
  SyncWoltCatalog = '[store] SyncWoltCatalog',
  SyncWoltCatalogSuccess = '[store] SyncWoltCatalogSuccess',
  SyncWoltCatalogFailed = '[store] SyncWoltCatalogFailed',

  SynchronizePosterCatalog = '[stores] SynchronizePosterCatalog',
  SynchronizePosterCatalogSuccess = '[stores] SynchronizePosterCatalogSuccess',
  SynchronizePosterCatalogFailed = '[stores] SynchronizePosterCatalogFailed',
  UpdateStoreRelation = '[stores] UpdateStoreRelation',
  UpdateStoreRelationSuccess = '[stores] UpdateStoreRelationSuccess',
  UpdateStoreRelationFailed = '[stores] UpdateStoreRelationFailed',
  CustomEndPointValidate = '[integrations] CustomEndPointValidate',
  CustomEndPointValidateSuccess = '[integrations] CustomEndPointValidateSuccess',
  CustomEndPointValidateFailed = '[integrations] CustomEndPointValidateFailed',
  LoadBasicDetailOfCustomer = '[customers] LoadBasicDetailOfCustomer',
  LoadBasicDetailOfCustomerSuccess = '[customers] LoadBasicDetailOfCustomerSuccess',
  LoadBasicDetailOfCustomerFailed = '[customers] LoadBasicDetailOfCustomerFailed',
  LoadCustomer = '[customers] LoadCustomer',
  LoadCustomerSuccess = '[customers] LoadCustomerSuccess',
  LoadCustomerFailed = '[customers] LoadCustomerFailed',
  LoadCustomerReset = '[customers] LoadCustomerReset',
  LoadCustomerOrderSummary = '[customers] LoadCustomerOrderSummary',
  LoadCustomerOrderSummarySuccess = '[customers] LoadCustomerOrderSummarySuccess',
  LoadCustomerOrderSummaryFailed = '[customers] LoadCustomerOrderSummaryFailed',
  LoadCustomerReservationStatistics = '[customers] LoadCustomerReservationStatistics',
  LoadCustomerReservationStatisticsSuccess = '[customers] LoadCustomerReservationStatisticsSuccess',
  LoadCustomerReservationStatisticsFailed = '[customers] LoadCustomerReservationStatisticsFailed',
  LoadCustomerEventBookingsStatistics = '[customers] LoadCustomerEventBookingsStatistics',
  LoadCustomerEventBookingsStatisticsSuccess = '[customers] LoadCustomerEventBookingsStatisticsSuccess',
  LoadCustomerEventBookingsStatisticsFailed = '[customers] LoadCustomerEventBookingsStatisticsFailed',
  LoadCustomerLoyaltyProfile = '[customers] LoadCustomerLoyaltyProfile',
  LoadCustomerLoyaltyProfileSuccess = '[customers] LoadCustomerLoyaltyProfileSuccess',
  LoadCustomerLoyaltyProfileFailed = '[customers] LoadCustomerLoyaltyProfileFailed',

  LoadCustomerLoyaltyProfileUpdate = '[customers] LoadCustomerLoyaltyProfileUpdate',
  LoadCustomerLoyaltyProfileUpdateSuccess = '[customers] LoadCustomerLoyaltyProfileUpdateSuccess',
  LoadCustomerLoyaltyProfileUpdateFailed = '[customers] LoadCustomerLoyaltyProfileUpdateFailed',

  LoadCustomerOrderItemsStatistics = '[customers] LoadCustomerOrderItemsStatistics',
  LoadCustomerOrderItemsStatisticsSuccess = '[customers] LoadCustomerOrderItemsStatisticsSuccess',
  LoadCustomerOrderItemsStatisticsFailed = '[customers] LoadCustomerOrderItemsStatisticsFailed',
  saveNewCustomer = '[customers] saveNewCustomer',
  saveCustomerFormSuccess = '[customers] saveCustomerFormSuccess',
  saveCustomerFormFailed = '[customers] saveCustomerFormFailed',
  LoadCustomerRecentOrdersSuccess = '[customers] LoadCustomerRecentOrdersSuccess',
  LoadCustomerRecentOrdersFailed = '[customers] LoadCustomerRecentOrdersFailed',
  LoadCustomerRecentOrders = '[customers] LoadCustomerRecentOrders',
  LoadCustomerLoyaltyTrasactionsSuccess = '[customers] LoadCustomerLoyaltyTrasactionsSuccess',
  LoadCustomerLoyaltyTrasactionsFailed = '[customers] LoadCustomerLoyaltyTrasactionsFailed',
  LoadCustomerLoyaltyTrasactions = '[customers] LoadCustomerLoyaltyTrasactions',
  LoadCustomerOrderItems = '[customers] LoadCustomerOrderItems',
  LoadCustomerOrderItemsSuccess = '[customers] LoadCustomerOrderItemsSuccess',
  LoadCustomerOrderItemsFailed = '[customers] LoadCustomerOrderItemsFailed',
  LoadCustomerReservationListSuccess = '[customers] LoadCustomerReservationListSuccess',
  LoadCustomerReservationListFailed = '[customers] LoadCustomerReservationListFailed',
  LoadCustomerReservationList = '[customers] LoadCustomerReservationList',
  AddNewEventBookingTier = '[stores] AddNewEventBookingTier',
  AddNewEventBookingTierSuccess = '[stores] AddNewEventBookingTierSuccess',
  AddNewEventBookingTierFailed = '[stores] AddNewEventBookingTierFailed',
  GetEvent = '[stores] GetEvent',
  GetEventSuccess = '[stores] GetEventSuccess',
  GetEventFailed = '[stores] GetEventFailed',
  ResetEventState = '[stores] ResetEventState',
  UpdateEvent = '[stores] UpdateEvent',
  UpdateEventSuccess = '[stores] UpdateEventSuccess',
  UpdateEventFailed = '[stores] UpdateEventFailed',
  DeleteEvent = '[stores] DeleteEvent',
  DeleteEventSuccess = '[stores] DeleteEventSuccess',
  DeleteEventFailed = '[stores] DeleteEventFailed',
  DeleteBookingTier = '[stores] DeleteBookingTier',
  DeleteBookingTierSuccess = '[stores] DeleteBookingTierSuccess',
  DeleteBookingTierFailed = '[stores] DeleteBookingTierFailed',
  UpdateBookingTier = '[stores] UpdateBookingTier',
  UpdateBookingTierSuccess = '[stores] UpdateBookingTierSuccess',
  UpdateBookingTierFailed = '[stores] UpdateBookingTierFailed',

  EposNowSyncCatalog = '[stores] EposNowSyncCatalog',
  EposNowSyncCatalogSuccess = '[stores] EposNowSyncCatalogSuccess',
  EposNowSyncCatalogFailed = '[stores] EposNowSyncCatalogFailed',

  SaveZonePosition = '[stores] SaveZonePosition',
  SaveZonePositionSuccess = '[stores] SaveZonePositionSuccess',
  SaveZonePositionFailed = '[stores] SaveZonePositionFailed',

  UploadStoreVideo = '[stores] UploadStoreVideo',
  UploadStoreVideoSuccess = '[stores] UploadStoreVideoSuccess',
  UploadStoreVideoFailed = '[stores] UploadStoreVideoFailed',

  TisslSyncCatalog = '[stores] TisslSyncCatalog',
  TisslSyncCatalogSuccess = '[stores] TisslSyncCatalogSuccess',
  TisslSyncCatalogFailed = '[stores] TisslSyncCatalogFailed',

  DownloadDailySummaryReport = '[stores] DownloadDailySummaryReport',
  DownloadDailySummaryReportSuccess = '[stores] DownloadDailySummaryReportSuccess',
  DownloadDailySummaryReportFailed = '[stores] DownloadDailySummaryReportFailed',

  PosIntegrationCatalogSync = '[stores] PosIntegrationCatalogSync',
  PosIntegrationCatalogSyncSuccess = '[stores] PosIntegrationCatalogSyncSuccess',
  PosIntegrationCatalogSyncFailed = '[stores] PosIntegrationCatalogSyncFailed',

  RegisterRefund = '[stores] RegisterRefund',
  RegisterRefundSuccess = '[stores] RegisterRefundSuccess',
  RegisterRefundFailed = '[stores] RegisterRefundFailed',
  LoadRefunds = '[stores] LoadRefunds',
  LoadRefundsSuccess = '[stores] LoadRefundsSuccess',
  LoadRefundsFailed = '[stores] LoadRefundsFailed',

  LoadProducts = '[products] LoadProducts',
  LoadProductsSuccess = '[products] LoadProductsSuccess',
  LoadProductsFailed = '[products] LoadProductsFailed',
  GetProduct = '[products] GetProduct',
  GetProductSuccess = '[products] GetProductSuccess',
  GetProductFailed = '[products] GetProductFailed',
  CreateProduct = '[products] CreateProduct',
  CreateProductSuccess = '[products] CreateProductSuccess',
  CreateProductFailed = '[products] CreateProductFailed',
  UpdateProduct = '[products] UpdateProduct',
  UpdateProductSuccess = '[products] UpdateProductSuccess',
  UpdateProductFailed = '[products] UpdateProductFailed',
  DeleteProduct = '[products] DeleteProduct',
  DeleteProductSuccess = '[products] DeleteProductSuccess',
  DeleteProductFailed = '[products] DeleteProductFailed',

  LoadPaymentTransactions = '[stores] LoadPaymentTransactions',
  LoadPaymentTransactionsSuccess = '[stores] LoadPaymentTransactionsSuccess',
  LoadPaymentTransactionsFailed = '[stores] LoadPaymentTransactionsFailed',

  InviteUserToRegister = '[stores] InviteUserToRegister',
  InviteUserToRegisterSuccess = '[stores] InviteUserToRegisterSuccess',
  InviteUserToRegisterFailed = '[stores] InviteUserToRegisterFailed',

  SetHierarchyType = '[stores] SetHierarchyType',
  SetHierarchyTypeSuccess = '[stores] SetHierarchyTypeSuccess',
  SetHierarchyTypeFailed = '[stores] SetHierarchyTypeFailed',
}

export class InitializeState implements Action {
  readonly type = StoresActionType.InitializeState;
  constructor() {}
}
export class LoadOrderItemsStatisticsPage implements Action {
  readonly type = StoresActionType.LoadOrderItemsStatisticsPage;
  constructor(
    public readonly id: number,
    public readonly startDate: string,
    public readonly endDate: string,
    public readonly orderItemDateType: string,
    public readonly paging: Paging,
    public readonly sort: string,
    public readonly parentOrderItemsOnly?: boolean,
  ) {}
}
export class LoadOrderItemsStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadOrderItemsStatisticsSuccess;
  constructor(
    public readonly orderItems: PageableResults<StoreOrderItemsStatistics>,
  ) {}
}
export class LoadOrderItemsStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadOrderItemsStatisticsFailed;
  constructor(public readonly error: string) {}
}
export class GetStatusOfZone implements Action {
  readonly type = StoresActionType.GetStatusOfZone;
  constructor() {}
}
export class GetStatusOfZoneSuccess implements Action {
  readonly type = StoresActionType.GetStatusOfZoneSuccess;
  constructor(public readonly status: StoreZoneStatus) {}
}
export class GetStatusOfZoneFailed implements Action {
  readonly type = StoresActionType.GetStatusOfZoneFailed;
  constructor(public readonly errors: string[]) {}
}
export class LoadStores implements Action {
  readonly type = StoresActionType.LoadStores;
  constructor(
    public readonly paging: Paging,
    public readonly aliasName: string,
    public readonly currentStoreId?: number | null,
    public readonly viewType?: string | null,
    public readonly deletedState?: string | null,
  ) {}
}
export class LoadStoresPage implements Action {
  readonly type = StoresActionType.LoadStoresPage;
  // Parameter order intentionally matches LoadStores so callers don't have to remember
  // which of the two actions takes currentStoreId and viewType in which slot.
  constructor(
    public readonly paging: Paging,
    public readonly aliasName: string,
    public readonly currentStoreId?: number,
    public readonly viewType?: string,
    public readonly deletedState?: string,
  ) {}
}
export class LoadStoresSuccess implements Action {
  readonly type = StoresActionType.LoadStoresSuccess;
  constructor(public readonly stores: PageableResults<ClientStore>) {}
}
export class LoadStoresFailed implements Action {
  readonly type = StoresActionType.LoadStoresFailed;
  constructor(public readonly error: string) {}
}
export class LoadStore implements Action {
  readonly type = StoresActionType.LoadStore;
  constructor(public readonly id: number) {}
}
export class LoadStoreSuccess implements Action {
  readonly type = StoresActionType.LoadStoreSuccess;
  constructor(public readonly store: ClientStore) {}
}
export class LoadStoreFailed implements Action {
  readonly type = StoresActionType.LoadStoreFailed;
  constructor() {}
}
export class InviteUser implements Action {
  readonly type = StoresActionType.InviteUser;
  constructor(
    public readonly email: string,
    public readonly role: string,
    public readonly storeId: any,
  ) {}
}
export class InviteUserSuccess implements Action {
  readonly type = StoresActionType.InviteUserSuccess;
  constructor() {}
}
export class InviteUserFailed implements Action {
  readonly type = StoresActionType.InviteUserFailed;
  constructor(public readonly errorMessages: string[]) {}
}
export class LoadUsers implements Action {
  readonly type = StoresActionType.LoadUsers;
  constructor(
    public storeId: number,
    public readonly paging: Paging,
  ) {}
}
export class LoadUsersPage implements Action {
  readonly type = StoresActionType.LoadUsersPage;
  constructor(
    public storeId: number,
    public readonly paging: Paging,
  ) {}
}
export class LoadUsersSuccess implements Action {
  readonly type = StoresActionType.LoadUsersSuccess;
  constructor(public readonly users: PageableResults<User>) {}
}
export class LoadUsersFailed implements Action {
  readonly type = StoresActionType.LoadUsersFailed;
  constructor(public readonly error: string) {}
}
export class ChangeAccountManager implements Action {
  readonly type = StoresActionType.ChangeAccountManager;
  constructor(
    public storeId: number,
    public readonly userId: number,
    public readonly paging: Paging,
  ) {}
}
export class ChangeAccountManagerSuccess implements Action {
  readonly type = StoresActionType.ChangeAccountManagerSuccess;
  constructor(
    public readonly storeId: number,
    public readonly paging: Paging,
  ) {}
}
export class ChangeAccountManagerFailed implements Action {
  readonly type = StoresActionType.ChangeAccountManagerFailed;
  constructor() {}
}
export class RemoveUserStoreAccess implements Action {
  readonly type = StoresActionType.RemoveUserStoreAccess;
  constructor(
    public readonly userId: number,
    public readonly storeId: number,
  ) {}
}
export class RemoveUserStoreAccessSuccess implements Action {
  readonly type = StoresActionType.RemoveUserStoreAccessSuccess;
  constructor(
    public readonly userId: number,
    public readonly storeId: number,
  ) {}
}
export class RemoveUserStoreAccessFailed implements Action {
  readonly type = StoresActionType.RemoveUserStoreAccessFailed;
  constructor() {}
}
export class RemoveZone implements Action {
  readonly type = StoresActionType.RemoveZone;
  constructor(
    public readonly zoneId: number,
    public readonly storeId: number,
  ) {}
}
export class RemoveZoneSuccess implements Action {
  readonly type = StoresActionType.RemoveZoneSuccess;

  constructor(
    public readonly zoneId: number,
    public readonly storeId: number,
  ) {}
}
export class RemoveZoneFailed implements Action {
  readonly type = StoresActionType.RemoveZoneFailed;

  constructor() {}
}

@ShowLoader()
export class CreateStore implements Action {
  readonly type = StoresActionType.CreateStore;
  constructor(
    public readonly clientStore: ClientStoreRequest,
    public readonly captchaToken: string,
  ) {}
}
@HideLoader(StoresActionType.CreateStore)
export class CreateStoreSuccess implements Action {
  readonly type = StoresActionType.CreateStoreSuccess;
  constructor(public readonly id: number) {}
}
@HideLoader(StoresActionType.CreateStore)
export class CreateStoreFailed implements Action {
  readonly type = StoresActionType.CreateStoreFailed;
  constructor(public readonly error?: string[]) {}
}
@ShowLoader()
export class PartialUpdateStore implements Action {
  readonly type = StoresActionType.PartialUpdateStore;
  constructor(public readonly clientStore: ClientStoreRequest) {}
}
@HideLoader(StoresActionType.PartialUpdateStore)
export class PartialUpdateStoreSuccess implements Action {
  readonly type = StoresActionType.PartialUpdateStoreSuccess;
  constructor(
    public readonly store: ClientStore,
    public readonly clientStore: ClientStoreRequest,
  ) {}
}
@HideLoader(StoresActionType.PartialUpdateStore)
export class PartialUpdateStoreFailed implements Action {
  readonly type = StoresActionType.PartialUpdateStoreFailed;
  constructor(public readonly error?: string[]) {}
}
export class DeleteStore implements Action {
  readonly type = StoresActionType.DeleteStore;
  constructor(public readonly storeId: number) {}
}
export class DeleteStoreSuccess implements Action {
  readonly type = StoresActionType.DeleteStoreSuccess;
  constructor(public readonly storeId: number) {}
}
export class DeleteStoreFailed implements Action {
  readonly type = StoresActionType.DeleteStoreFailed;
  constructor(public readonly error?: string[]) {}
}
export class DeleteStoreParent implements Action {
  readonly type = StoresActionType.DeleteStoreParent;
  constructor(public readonly storeId: number) {}
}
export class DeleteStoreParentSuccess implements Action {
  readonly type = StoresActionType.DeleteStoreParentSuccess;
  constructor(public readonly storeId: number) {}
}
export class DeleteStoreParentFailed implements Action {
  readonly type = StoresActionType.DeleteStoreParentFailed;
  constructor(public readonly error?: string[]) {}
}
@ShowLoader()
export class UpdateStore implements Action {
  readonly type = StoresActionType.UpdateStore;
  constructor(public readonly clientStore: ClientStoreRequest) {}
}
@HideLoader(StoresActionType.UpdateStore)
export class UpdateStoreSuccess implements Action {
  readonly type = StoresActionType.UpdateStoreSuccess;
  constructor(public readonly store: ClientStore) {}
}
@HideLoader(StoresActionType.UpdateStore)
export class UpdateStoreFailed implements Action {
  readonly type = StoresActionType.UpdateStoreFailed;
  constructor(public readonly error?: string[]) {}
}
@ShowLoader()
export class UpdateStoreRelation implements Action {
  readonly type = StoresActionType.UpdateStoreRelation;
  constructor(
    public readonly storeRelationRequest: StoreRelationRequest,
    public readonly parentStoreDetail: any,
    public readonly isUpdate?: boolean,
  ) {}
}
@HideLoader(StoresActionType.UpdateStoreRelation)
export class UpdateStoreRelationSuccess implements Action {
  readonly type = StoresActionType.UpdateStoreRelationSuccess;
  constructor(
    public readonly storeId: number,
    public readonly parentStoreRelations: any,
  ) {}
}
@HideLoader(StoresActionType.UpdateStoreRelation)
export class UpdateStoreRelationFailed implements Action {
  readonly type = StoresActionType.UpdateStoreRelationFailed;
  constructor(public readonly error?: string[]) {}
}
export class UpdateStoreVatPercentage implements Action {
  readonly type = StoresActionType.UpdateStoreVatPercentage;
  constructor(public readonly vatPercentage: number) {}
}
export class UpdateStoreVatPercentageSuccess implements Action {
  readonly type = StoresActionType.UpdateStoreVatPercentageSuccess;
  constructor(public readonly store: ClientStore) {}
}
export class UpdateStoreVatPercentageFailed implements Action {
  readonly type = StoresActionType.UpdateStoreVatPercentageFailed;
  constructor(public readonly error?: string[]) {}
}
export class UpdateStoreSettings implements Action {
  readonly type = StoresActionType.UpdateStoreSettings;
  constructor(public readonly settings: { [key: string]: any }) {}
}
export class UpdateStoreSettingsSuccess implements Action {
  readonly type = StoresActionType.UpdateStoreSettingsSuccess;
  constructor(public readonly store: ClientStore) {}
}
export class UpdateStoreSettingsFailed implements Action {
  readonly type = StoresActionType.UpdateStoreSettingsFailed;
  constructor(
    public readonly storeId?: number,
    public readonly error?: string[],
  ) {}
}
export class DownloadQRImage implements Action {
  readonly type = StoresActionType.DownloadQRImage;
  constructor(
    public readonly id: number,
    public readonly url: string,
  ) {}
}
export class DownloadQRImageSuccess implements Action {
  readonly type = StoresActionType.DownloadQRImageSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadQRImageFailed implements Action {
  readonly type = StoresActionType.DownloadQRImageFailed;
  constructor(public readonly error: string) {}
}
export class DownloadQRPdf implements Action {
  readonly type = StoresActionType.DownloadQRPdf;
  constructor(public readonly id: number) {}
}
export class DownloadQRPdfSuccess implements Action {
  readonly type = StoresActionType.DownloadQRPdfSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadQRPdfFailed implements Action {
  readonly type = StoresActionType.DownloadQRPdfFailed;
  constructor(public readonly error: string) {}
}
export class DownloadQRImages implements Action {
  readonly type = StoresActionType.DownloadQRImages;
  constructor(public readonly id: number) {}
}
export class DownloadQRImagesSuccess implements Action {
  readonly type = StoresActionType.DownloadQRImagesSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadQRImagesFailed implements Action {
  readonly type = StoresActionType.DownloadQRImagesFailed;
  constructor(public readonly error: string) {}
}
export class DownloadQRFullPdf implements Action {
  readonly type = StoresActionType.DownloadQRFullPdf;
  constructor(public readonly id: number) {}
}
export class DownloadQRFullPdfSuccess implements Action {
  readonly type = StoresActionType.DownloadQRFullPdfSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadQRFullPdfFailed implements Action {
  readonly type = StoresActionType.DownloadQRFullPdfFailed;
  constructor(public readonly error: string) {}
}
@ShowLoader()
export class UploadStoreImage implements Action {
  readonly type = StoresActionType.UploadStoreImage;
  constructor(
    public readonly file: File,
    public readonly backgroundImage = false,
  ) {}
}
@HideLoader(StoresActionType.UploadStoreImage)
export class UploadStoreImageSuccess implements Action {
  readonly type = StoresActionType.UploadStoreImageSuccess;
  constructor(
    public readonly imageUrl: string,
    public readonly backgroundImage = false,
  ) {}
}
@HideLoader(StoresActionType.UploadStoreImage)
export class UploadStoreImageFailed implements Action {
  readonly type = StoresActionType.UploadStoreImageFailed;
  constructor(
    public readonly errorMessages: string[],
    public readonly backgroundImage = false,
  ) {}
}
@ShowLoader()
export class UploadStoreLogo implements Action {
  readonly type = StoresActionType.UploadStoreLogo;
  constructor(public readonly file: File) {}
}
@HideLoader(StoresActionType.UploadStoreLogo)
export class UploadStoreLogoSuccess implements Action {
  readonly type = StoresActionType.UploadStoreLogoSuccess;
  constructor(public readonly imageUrl: string) {}
}
@HideLoader(StoresActionType.UploadStoreLogo)
export class UploadStoreLogoFailed implements Action {
  readonly type = StoresActionType.UploadStoreLogoFailed;
  constructor(public readonly errorMessages: string[]) {}
}
export class SearchStores implements Action {
  readonly type = StoresActionType.SearchStores;
  // Named criteria rather than positional args: LoadStores and SearchStores take an
  // overlapping-but-differently-ordered set of parameters, so positional additions here
  // are an easy source of silently-swapped arguments.
  constructor(public readonly criteria: StoreSearchCriteria) {}
}
export class SearchStoresSuccess implements Action {
  readonly type = StoresActionType.SearchStoresSuccess;
  constructor(public readonly stores: PageableResults<ClientStore>) {}
}
export class SearchStoresFailed implements Action {
  readonly type = StoresActionType.SearchStoresFailed;
  constructor(public readonly error: string) {}
}
export class LoadStoreStatistics implements Action {
  readonly type = StoresActionType.LoadStoreStatistics;
  constructor(
    public readonly duration: number,
    public readonly from: string,
    public readonly to: string,
    public readonly periodicTerm: string,
  ) {}
}
export class LoadStoreStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadStoreStatisticsSuccess;
  constructor(public readonly statistics: StoreStatistics[]) {}
}
export class LoadStoreStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadStoreStatisticsFailed;
  constructor(public readonly error: string) {}
}
export class LoadMenuViewingStatistics implements Action {
  readonly type = StoresActionType.LoadMenuViewingStatistics;
  constructor(
    public readonly duration: number,
    public readonly from: string,
    public readonly to: string,
    public readonly periodicTerm: string,
  ) {}
}
export class LoadMenuViewingStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadMenuViewingStatisticsSuccess;
  constructor(public readonly statistics: StoreStatistics[]) {}
}
export class LoadMenuViewingStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadMenuViewingStatisticsFailed;
  constructor(public readonly error: string) {}
}
export class LoadLoyaltyStatistics implements Action {
  readonly type = StoresActionType.LoadLoyaltyStatistics;
  constructor(
    public readonly storeId: number,
    public readonly from: string,
    public readonly to: string,
    public readonly period: string,
    public readonly groupBy: string,
  ) {}
}
export class LoadLoyaltyStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadLoyaltyStatisticsSuccess;
  constructor(
    public readonly statistics: any,
    public readonly groupBy: string,
  ) {}
}
export class LoadLoyaltyStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadLoyaltyStatisticsFailed;
  constructor(public readonly error: string) {}
}
export class ClearLoyaltyStatistics implements Action {
  readonly type = StoresActionType.ClearLoyaltyStatistics;
  constructor() {}
}
export class ValidateAliasAvailability implements Action {
  readonly type = StoresActionType.ValidateAliasAvailability;
  constructor(
    public readonly storeId: number,
    public readonly alias: string,
  ) {}
}
export class ValidateAliasAvailabilitySuccess implements Action {
  readonly type = StoresActionType.ValidateAliasAvailabilitySuccess;
  constructor(public readonly status: AliasAvailabilityStatus) {}
}
export class ValidateAliasAvailabilityFailed implements Action {
  readonly type = StoresActionType.ValidateAliasAvailabilityFailed;
  constructor(public readonly error: string) {}
}
export class ValidateAliasAvailabilityReset implements Action {
  readonly type = StoresActionType.ValidateAliasAvailabilityReset;
  constructor() {}
}
export class LoadNotificationSubscriptionStatus implements Action {
  readonly type = StoresActionType.LoadNotificationSubscriptionStatus;
  constructor(
    public readonly storeId: number,
    public readonly pushSubscription: PushSubscription,
  ) {}
}
export class LoadNotificationSubscriptionStatusSuccess implements Action {
  readonly type = StoresActionType.LoadNotificationSubscriptionStatusSuccess;
  constructor(public readonly subscriptionStatus: boolean) {}
}
export class LoadNotificationSubscriptionStatusFailed implements Action {
  readonly type = StoresActionType.LoadNotificationSubscriptionStatusFailed;
  constructor(public readonly errors: string[]) {}
}
export class RequestNotificationPermission implements Action {
  readonly type = StoresActionType.RequestNotificationPermission;
  constructor() {}
}
export class ToggleNotificationSubscriptionStatus implements Action {
  readonly type = StoresActionType.ToggleNotificationSubscriptionStatus;
  constructor(
    public readonly newStatus: boolean,
    public readonly pushSubscription: PushSubscription,
  ) {}
}
export class ToggleNotificationSubscriptionStatusSuccess implements Action {
  readonly type = StoresActionType.ToggleNotificationSubscriptionStatusSuccess;
  constructor(public readonly newStatus: boolean) {}
}
export class ToggleNotificationPermitted implements Action {
  readonly type = StoresActionType.ToggleNotificationPermitted;
  constructor(public readonly permissionStatus: boolean) {}
}
export class UpdateNotificationSubscriptions implements Action {
  readonly type = StoresActionType.UpdateNotificationSubscriptions;
  constructor(public readonly subscriptions: NotificationSubscriptions) {}
}
export class LoadAutoprintSubscriptionStatus implements Action {
  readonly type = StoresActionType.LoadAutoprintSubscriptionStatus;
  constructor(public readonly storeId: number) {}
}
export class LoadAutoprintSubscriptionStatusSuccess implements Action {
  readonly type = StoresActionType.LoadAutoprintSubscriptionStatusSuccess;
  constructor(public readonly autoprintStatus: boolean) {}
}
export class LoadAutoprintSubscriptionStatusFailed implements Action {
  readonly type = StoresActionType.LoadAutoprintSubscriptionStatusFailed;
  constructor(public readonly errors: string[]) {}
}
export class RequestAutoprintPermission implements Action {
  readonly type = StoresActionType.RequestAutoprintPermission;
  constructor() {}
}
export class ToggleAutoprintSubscriptionStatus implements Action {
  readonly type = StoresActionType.ToggleAutoprintSubscriptionStatus;
  constructor(public readonly newStatus: boolean) {}
}
export class ToggleAutoprintSubscriptionStatusSuccess implements Action {
  readonly type = StoresActionType.ToggleAutoprintSubscriptionStatusSuccess;
  constructor(public readonly newStatus: boolean) {}
}
export class ToggleAutoprintPermitted implements Action {
  readonly type = StoresActionType.ToggleAutoprintPermitted;
  constructor(public readonly permissionStatus: boolean) {}
}
export class CreateOrUpdateZone implements Action {
  readonly type = StoresActionType.CreateOrUpdateZone;
  constructor(
    public readonly zoneSetting: StoreZone,
    public readonly id: number = 0,
  ) {}
}
export class CreateOrUpdateZoneSuccess implements Action {
  readonly type = StoresActionType.CreateOrUpdateZoneSuccess;
  constructor(
    public readonly storeId: number,
    public readonly zoneId: number,
    public readonly zoneType?: string,
  ) {}
}
export class CreateOrUpdateZoneFailed implements Action {
  readonly type = StoresActionType.CreateOrUpdateZoneFailed;
  constructor(public readonly error: string[]) {}
}
export class LoadZones implements Action {
  readonly type = StoresActionType.LoadZones;
  constructor() {}
}
export class LoadZonesSuccess implements Action {
  readonly type = StoresActionType.LoadZonesSuccess;
  constructor(public readonly zones: StoreZone[]) {}
}
export class LoadZonesFailed implements Action {
  readonly type = StoresActionType.LoadZonesFailed;
  constructor(public readonly error: string) {}
}
export class LoadZone implements Action {
  readonly type = StoresActionType.LoadZone;
  constructor(
    public readonly storeId: number,
    public readonly id: number,
  ) {}
}
export class LoadZoneSuccess implements Action {
  readonly type = StoresActionType.LoadZoneSuccess;
  constructor(public readonly zone: StoreZone) {}
}
export class LoadZoneFailed implements Action {
  readonly type = StoresActionType.LoadZoneFailed;
  constructor() {}
}
@ShowLoader()
export class RemoveStoreLogo implements Action {
  readonly type = StoresActionType.RemoveStoreLogo;
  constructor(public readonly storeId: number) {}
}
@HideLoader(StoresActionType.RemoveStoreLogo)
export class RemoveStoreLogoSuccess implements Action {
  readonly type = StoresActionType.RemoveStoreLogoSuccess;
  constructor(public readonly storeId: number) {}
}
@HideLoader(StoresActionType.RemoveStoreLogo)
export class RemoveStoreLogoFailed implements Action {
  readonly type = StoresActionType.RemoveStoreLogoFailed;
  constructor() {}
}
@ShowLoader()
export class RemoveStoreImage implements Action {
  readonly type = StoresActionType.RemoveStoreImage;
  constructor(
    public readonly storeId: number,
    public readonly backgroundImage = false,
  ) {}
}
@HideLoader(StoresActionType.RemoveStoreImage)
export class RemoveStoreImageSuccess implements Action {
  readonly type = StoresActionType.RemoveStoreImageSuccess;
  constructor(
    public readonly storeId: number,
    public readonly backgroundImage = false,
  ) {}
}
@HideLoader(StoresActionType.RemoveStoreImage)
export class RemoveStoreImageFailed implements Action {
  readonly type = StoresActionType.RemoveStoreImageFailed;
  constructor() {}
}
/**
 * Removes the store header video (story #11770): the stored file and the
 * HEADER_VIDEO setting together, so the storefront banner falls back to the
 * store image. Modelled on RemoveStoreImage / RemoveStoreLogo, which also call
 * a delete endpoint rather than blanking a setting.
 */
@ShowLoader()
export class RemoveStoreHeaderVideo implements Action {
  readonly type = StoresActionType.RemoveStoreHeaderVideo;
  constructor(public readonly storeId: number) {}
}
@HideLoader(StoresActionType.RemoveStoreHeaderVideo)
export class RemoveStoreHeaderVideoSuccess implements Action {
  readonly type = StoresActionType.RemoveStoreHeaderVideoSuccess;
  constructor(public readonly storeId: number) {}
}
@HideLoader(StoresActionType.RemoveStoreHeaderVideo)
export class RemoveStoreHeaderVideoFailed implements Action {
  readonly type = StoresActionType.RemoveStoreHeaderVideoFailed;
  constructor() {}
}
export class CheckStoreHasNewOrder implements Action {
  readonly type = StoresActionType.CheckStoreHasNewOrder;
  constructor() {}
}
export class CheckStoreHasNewOrderSuccess implements Action {
  readonly type = StoresActionType.CheckStoreHasNewOrderSuccess;
  constructor(public readonly orders: PageableResults<ClientStoreOrder>) {}
}
export class CheckStoreHasNewOrderFailed implements Action {
  readonly type = StoresActionType.CheckStoreHasNewOrderFailed;
  constructor() {}
}
export class StartOrderNotificationSound implements Action {
  readonly type = StoresActionType.StartOrderNotificationSound;
  constructor(public readonly audioSrc: string) {}
}
export class DownloadOrderItemsXls implements Action {
  readonly type = StoresActionType.DownloadOrderItemsXls;
  constructor(
    public readonly storeId: number,
    public readonly orderItemReportType: string,
    public readonly fromDate: string,
    public readonly toDate: string,
    public readonly showAllOrderItems?: boolean,
  ) {}
}
export class DownloadOrderItemsXlsSuccess implements Action {
  readonly type = StoresActionType.DownloadOrderItemsXlsSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadOrderItemsXlsFailed implements Action {
  readonly type = StoresActionType.DownloadOrderItemsXlsFailed;
  constructor(public readonly error: string) {}
}
export class InitializeStoreUserExperience implements Action {
  readonly type = StoresActionType.InitializeStoreUserExperience;
  constructor(public readonly storeId: number) {}
}
export class UpdateStoreTabUserExperience implements Action {
  readonly type = StoresActionType.UpdateStoreTabUserExperience;
  constructor(
    public readonly storeId: number,
    public readonly tabName: string,
    public readonly tabUserExperience: TabUserExperience,
  ) {}
}
export class UpdateStoreTab implements Action {
  readonly type = StoresActionType.UpdateStoreTab;
  constructor(
    public readonly storeId: number,
    public readonly newTab,
  ) {}
}
export class UpdateStoreZoneSettings implements Action {
  readonly type = StoresActionType.UpdateStoreZoneSettings;
  constructor(
    public readonly id: number,
    public readonly settings: { [key: string]: any },
  ) {}
}
export class UpdateStoreZoneSettingsSuccess implements Action {
  readonly type = StoresActionType.UpdateStoreZoneSettingsSuccess;
  constructor(public readonly zone: StoreZone) {}
}
export class UpdateStoreZoneSettingsFailed implements Action {
  readonly type = StoresActionType.UpdateStoreZoneSettingsFailed;
  constructor(public readonly error?: string[]) {}
}

@ShowLoader()
export class MynextLogin implements Action {
  readonly type = StoresActionType.MynextLogin;
  constructor(
    public readonly storeId: number,
    public readonly username: string,
    public readonly password: string,
    public readonly venueId?: string,
    public readonly webhookApiKey?: string,
  ) {}
}

@HideLoader(StoresActionType.MynextLogin)
export class MynextLoginSuccess implements Action {
  readonly type = StoresActionType.MynextLoginSuccess;
  constructor(public readonly store: ClientStore) {}
}

@HideLoader(StoresActionType.MynextLogin)
export class MynextLoginFailed implements Action {
  readonly type = StoresActionType.MynextLoginFailed;
  constructor() {}
}
export class PowersoftLogin implements Action {
  readonly type = StoresActionType.PowersoftLogin;
  constructor(
    public readonly storeId: number,
    public readonly reqObj: PowersoftLoginRequest,
  ) {}
}
export class PowersoftLoginSuccess implements Action {
  readonly type = StoresActionType.PowersoftLoginSuccess;
  constructor(public readonly store: ClientStore) {}
}
export class PowersoftLoginFailed implements Action {
  readonly type = StoresActionType.PowersoftLoginFailed;
  constructor(public readonly error: string) {}
}
export class DisconnectPowersoft implements Action {
  readonly type = StoresActionType.DisconnectPowersoft;
  constructor(public readonly storeId: number) {}
}
export class DisconnectPowersoftSuccess implements Action {
  readonly type = StoresActionType.DisconnectPowersoftSuccess;
  constructor(public readonly store: ClientStore) {}
}
export class DisconnectPowersoftFailed implements Action {
  readonly type = StoresActionType.DisconnectPowersoftFailed;
  constructor(public readonly error: string) {}
}
export class SynchronizePowersoftCatalog implements Action {
  readonly type = StoresActionType.SynchronizePowersoftCatalog;
  constructor(public readonly storeId: number) {}
}
export class SynchronizePowersoftCatalogSuccess implements Action {
  readonly type = StoresActionType.SynchronizePowersoftCatalogSuccess;
  constructor() {}
}
export class SynchronizePowersoftCatalogFailed implements Action {
  readonly type = StoresActionType.SynchronizePowersoftCatalogFailed;
  constructor(public readonly error: string) {}
}

export class WoltLogin implements Action {
  readonly type = StoresActionType.WoltLogin;

  constructor(
    public readonly storeId: number,
    public readonly reqObj: WoltLoginRequest,
  ) {}
}

export class WoltLoginSuccess implements Action {
  readonly type = StoresActionType.WoltLoginSuccess;

  constructor(public readonly store: ClientStore) {}
}

export class WoltLoginFailed implements Action {
  readonly type = StoresActionType.WoltLoginFailed;

  constructor(public readonly error: string) {}
}

export class DisconnectWolt implements Action {
  readonly type = StoresActionType.DisconnectWolt;

  constructor(public readonly storeId: number) {}
}

export class DisconnectWoltSuccess implements Action {
  readonly type = StoresActionType.DisconnectWoltSuccess;

  constructor(public readonly store: ClientStore) {}
}

export class DisconnectWoltFailed implements Action {
  readonly type = StoresActionType.DisconnectWoltFailed;

  constructor(public readonly error: string) {}
}

export class DisconnectMyNext implements Action {
  readonly type = StoresActionType.DisconnectMyNext;

  constructor(public readonly storeId: number) {}
}

export class DisconnectMyNextSuccess implements Action {
  readonly type = StoresActionType.DisconnectMyNextSuccess;

  constructor(public readonly store: ClientStore) {}
}

export class DisconnectMyNextFailed implements Action {
  readonly type = StoresActionType.DisconnectMyNextFailed;

  constructor(public readonly error: string) {}
}

export class SyncWoltCatalog implements Action {
  readonly type = StoresActionType.SyncWoltCatalog;

  constructor(public readonly storeId: number) {}
}

export class SyncWoltCatalogSuccess implements Action {
  readonly type = StoresActionType.SyncWoltCatalogSuccess;

  constructor(public readonly store: ClientStore) {}
}

export class SyncWoltCatalogFailed implements Action {
  readonly type = StoresActionType.SyncWoltCatalogFailed;

  constructor(public readonly error: string) {}
}

export class SynchronizePosterCatalog implements Action {
  readonly type = StoresActionType.SynchronizePosterCatalog;
  constructor(public readonly storeId: number) {}
}
export class SynchronizePosterCatalogSuccess implements Action {
  readonly type = StoresActionType.SynchronizePosterCatalogSuccess;
  constructor() {}
}
export class SynchronizePosterCatalogFailed implements Action {
  readonly type = StoresActionType.SynchronizePosterCatalogFailed;
  constructor(public readonly error: string) {}
}
export class ClearStoreValidation implements Action {
  readonly type = StoresActionType.ClearStoreValidation;
  constructor(public readonly error?: string[]) {}
}
export class HubriseLogin implements Action {
  readonly type = StoresActionType.HubriseLogin;
  constructor(
    public storeId: number,
    public readonly authCode: string,
  ) {}
}
export class HubriseLoginSuccess implements Action {
  readonly type = StoresActionType.HubriseLoginSuccess;
  constructor(public readonly response: ClientStore) {}
}
export class HubriseLoginFailed implements Action {
  readonly type = StoresActionType.HubriseLoginFailed;
  constructor() {}
}
export class HubriseLogout implements Action {
  readonly type = StoresActionType.HubriseLogout;
  constructor(public storeId: number) {}
}
export class HubriseLogoutSuccess implements Action {
  readonly type = StoresActionType.HubriseLogoutSuccess;
  constructor(public readonly response: ClientStore) {}
}
export class HubriseLogoutFailed implements Action {
  readonly type = StoresActionType.HubriseLogoutFailed;
  constructor() {}
}
export class ClearHubriseData implements Action {
  readonly type = StoresActionType.ClearHubriseData;
  constructor() {}
}
export class LoadCustomersPage implements Action {
  readonly type = StoresActionType.LoadCustomersPage;
  constructor(
    public storeId: number,
    public readonly email: string,
    public readonly name: string,
    public readonly phoneNumber: string,
    public readonly customerCode: string,
    public readonly sortingColumn: string,
    public readonly paging: Paging,
    public readonly birthdayFrom?: string,
    public readonly birthdayTo?: string,
    public readonly customerType?: CustomerType,
  ) {}
}
export class LoadCustomersSuccess implements Action {
  readonly type = StoresActionType.LoadCustomersSuccess;
  constructor(public readonly customers: PageableResults<Customer>) {}
}
export class LoadCustomersFailed implements Action {
  readonly type = StoresActionType.LoadCustomersFailed;
  constructor(public readonly error: string) {}
}

export class TopOrderCustomersPage implements Action {
  readonly type = StoresActionType.TopOrderCustomersPage;
  constructor(
    public storeId: number,
    public readonly paging: Paging,
  ) {}
}
export class TopOrderCustomersSuccess implements Action {
  readonly type = StoresActionType.TopOrderCustomersSuccess;
  constructor(public readonly customers: any) {}
}
export class TopOrderCustomersFailed implements Action {
  readonly type = StoresActionType.TopOrderCustomersFailed;
  constructor(public readonly error: string) {}
}
export class TopReservationCustomersPage implements Action {
  readonly type = StoresActionType.TopReservationCustomersPage;
  constructor(
    public storeId: number,
    public readonly paging: Paging,
  ) {}
}
export class TopReservationCustomersSuccess implements Action {
  readonly type = StoresActionType.TopReservationCustomersSuccess;
  constructor(public readonly customers: any) {}
}
export class TopReservationCustomersFailed implements Action {
  readonly type = StoresActionType.TopReservationCustomersFailed;
  constructor(public readonly error: string) {}
}
export class DownloadCustomersList implements Action {
  readonly type = StoresActionType.DownloadCustomersList;
  constructor(
    public readonly storeId: number,
    public readonly email: string,
    public readonly name: string,
    public readonly phoneNumber: string,
  ) {}
}
export class DownloadCustomersListSuccess implements Action {
  readonly type = StoresActionType.DownloadCustomersListSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadCustomersListFailed implements Action {
  readonly type = StoresActionType.DownloadCustomersListFailed;
  constructor(public readonly error: string) {}
}
export class DownloadFlyerFile implements Action {
  readonly type = StoresActionType.DownloadFlyerFile;
  constructor(
    public readonly storeId: number,
    public readonly voucherCode: string,
  ) {}
}
export class DownloadFlyerFileSuccess implements Action {
  readonly type = StoresActionType.DownloadFlyerFileSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}
export class DownloadFlyerFileFailed implements Action {
  readonly type = StoresActionType.DownloadFlyerFileFailed;
  constructor(public readonly error: string) {}
}
export class CustomEndPointValidate implements Action {
  readonly type = StoresActionType.CustomEndPointValidate;
  constructor(
    public readonly storeId,
    public readonly method,
    public readonly customEndPointValidationRequest: CustomEndPointValidationRequest,
  ) {}
}
export class CustomEndPointValidateSuccess implements Action {
  readonly type = StoresActionType.CustomEndPointValidateSuccess;
  constructor(
    public readonly endpoint: string,
    public readonly validationEndpoint: string,
  ) {}
}
export class CustomEndPointValidateFailed implements Action {
  readonly type = StoresActionType.CustomEndPointValidateFailed;
  constructor(public readonly error: string) {}
}
export class LoadBasicCustomerSuccess implements Action {
  readonly type = StoresActionType.LoadBasicDetailOfCustomerSuccess;
  constructor(public readonly customer: CustomerBasic) {}
}
export class LoadBasicCustomer implements Action {
  readonly type = StoresActionType.LoadBasicDetailOfCustomer;
  constructor(
    public readonly storeId: number,
    public readonly customerParams: { [key: string]: any },
  ) {}
}
export class LoadBasicCustomerFailed implements Action {
  readonly type = StoresActionType.LoadBasicDetailOfCustomerFailed;
  constructor() {}
}
export class LoadCustomer implements Action {
  readonly type = StoresActionType.LoadCustomer;
  constructor(
    public readonly id: number,
    public readonly storeId: number,
  ) {}
}
export class LoadCustomerSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerSuccess;
  constructor(public readonly customer: CustomerDetail) {}
}
export class LoadCustomerReset implements Action {
  readonly type = StoresActionType.LoadCustomerReset;
  constructor() {}
}
export class LoadCustomerFailed implements Action {
  readonly type = StoresActionType.LoadCustomerFailed;
  constructor() {}
}
export class LoadCustomerOrderSummary implements Action {
  readonly type = StoresActionType.LoadCustomerOrderSummary;
  constructor(
    public readonly storeId: number,
    public readonly customerParams: { [key: string]: any },
  ) {}
}
export class LoadCustomerOrderSummarySuccess implements Action {
  readonly type = StoresActionType.LoadCustomerOrderSummarySuccess;
  constructor(public readonly orderSummary: CustomerOrderSummary) {}
}
export class LoadCustomerOrderSummaryFailed implements Action {
  readonly type = StoresActionType.LoadCustomerOrderSummaryFailed;
  constructor() {}
}
export class LoadCustomerReservationStatistics implements Action {
  readonly type = StoresActionType.LoadCustomerReservationStatistics;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
  ) {}
}
export class LoadCustomerReservationStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerReservationStatisticsSuccess;
  constructor(
    public readonly reservationStatistics: CustomerReservationStatistics,
  ) {}
}
export class LoadCustomerReservationStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadCustomerReservationStatisticsFailed;
  constructor() {}
}

export class LoadCustomerEventBookingsStatistics implements Action {
  readonly type = StoresActionType.LoadCustomerEventBookingsStatistics;
  constructor(
    public readonly userId: number,
    public readonly storeId: number,
  ) {}
}
export class LoadCustomerEventBookingsStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerEventBookingsStatisticsSuccess;
  constructor(public readonly eventBookingStatistics: any) {}
}
export class LoadCustomerEventBookingsStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadCustomerEventBookingsStatisticsFailed;
  constructor() {}
}
export class LoadCustomerLoyaltyProfileUpdate implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyProfileUpdate;
  constructor(
    public readonly customerId: number,
    public readonly storeId: number,
    public readonly loyaltyData: CustomerLoyaltyProfileUpdateData,
  ) {}
}
export class LoadCustomerLoyaltyProfileUpdateSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyProfileUpdateSuccess;
  constructor(public readonly loyaltyProfile: CustomerLoyaltyProfile) {}
}
export class LoadCustomerLoyaltyProfileUpdateFailed implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyProfileUpdateFailed;
  constructor(public readonly error: string[]) {}
}

export class LoadCustomerLoyaltyProfile implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyProfile;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
  ) {}
}
export class LoadCustomerLoyaltyProfileSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyProfileSuccess;
  constructor(public readonly loyaltyProfile: CustomerLoyaltyProfile) {}
}
export class LoadCustomerLoyaltyProfileFailed implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyProfileFailed;
  constructor() {}
}
export class LoadCustomerOrderItemsStatistics implements Action {
  readonly type = StoresActionType.LoadCustomerOrderItemsStatistics;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
    public readonly size: number,
    public readonly sort: string,
  ) {}
}
export class LoadCustomerOrderItemsStatisticsSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerOrderItemsStatisticsSuccess;
  constructor(public readonly OrederItems: CustomerOrderItems) {}
}
export class LoadCustomerOrderItemsStatisticsFailed implements Action {
  readonly type = StoresActionType.LoadCustomerOrderItemsStatisticsFailed;
  constructor() {}
}
export class LoadCustomerRecentOrders implements Action {
  readonly type = StoresActionType.LoadCustomerRecentOrders;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
    public readonly size: number,
    public readonly sort: string,
    public readonly paging: Paging,
  ) {}
}
export class LoadCustomerRecentOrdersSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerRecentOrdersSuccess;
  constructor(public readonly OrederItems: Page<OrderItem>) {}
}
export class LoadCustomerRecentOrdersFailed implements Action {
  readonly type = StoresActionType.LoadCustomerRecentOrdersFailed;
  constructor() {}
}
export class LoadCustomerLoyaltyTrasactions implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyTrasactions;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
    public readonly size: number,
    public readonly sort: string,
    public readonly paging: Paging,
  ) {}
}
export class LoadCustomerLoyaltyTrasactionsSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyTrasactionsSuccess;
  constructor(public readonly OrederItems: Page<CustomerLoyaltyTrasaction>) {}
}
export class LoadCustomerLoyaltyTrasactionsFailed implements Action {
  readonly type = StoresActionType.LoadCustomerLoyaltyTrasactionsFailed;
  constructor() {}
}
export class LoadCustomerOrderItems implements Action {
  readonly type = StoresActionType.LoadCustomerOrderItems;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
    public readonly size: number,
    public readonly sort: string,
    public readonly paging: Paging,
    public readonly parentOrderItemsOnly?: boolean,
  ) {}
}
export class LoadCustomerOrderItemsSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerOrderItemsSuccess;
  constructor(
    public readonly OrederItems: PageableResults<CustomerOrderItem>,
  ) {}
}
export class LoadCustomerOrderItemsFailed implements Action {
  readonly type = StoresActionType.LoadCustomerOrderItemsFailed;
  constructor() {}
}
export class LoadCustomerReservationList implements Action {
  readonly type = StoresActionType.LoadCustomerReservationList;
  constructor(
    public readonly customerParams: { [key: string]: any },
    public readonly storeId: number,
    public readonly size: number,
    public readonly sort: string,
    public readonly paging: Paging,
  ) {}
}
export class LoadCustomerReservationListSuccess implements Action {
  readonly type = StoresActionType.LoadCustomerReservationListSuccess;
  constructor(public readonly ReservationItems: Page<CustomerReservation>) {}
}
export class LoadCustomerReservationListFailed implements Action {
  readonly type = StoresActionType.LoadCustomerReservationListFailed;
  constructor() {}
}
@ShowLoader()
export class SaveCustomerForm implements Action {
  readonly type = StoresActionType.saveNewCustomer;
  constructor(
    public readonly id: number,
    public readonly storeId: number,
    public readonly customerPostForm: CustomerForm,
    public readonly redirectionUrl: string,
  ) {}
}
@HideLoader(StoresActionType.saveNewCustomer)
export class SaveCustomerFormSuccess implements Action {
  readonly type = StoresActionType.saveCustomerFormSuccess;
  constructor() {}
}
@HideLoader(StoresActionType.saveNewCustomer)
export class SaveCustomerFormFailed implements Action {
  readonly type = StoresActionType.saveCustomerFormFailed;
  /**
   * @param alreadyCustomerEmail set when a new customer could not be added because this store
   *     already has them (#10368); the create page offers to open that customer instead.
   * @param alreadyInGroup set when the backend said another store of the loyalty group has them
   *     (CUSTOMER_ALREADY_IN_GROUP): this store's list cannot show them, so there is nothing to open.
   */
  constructor(
    public alreadyCustomerEmail?: string,
    public alreadyInGroup = false,
  ) {}
}
@ShowLoader()
export class AddNewEventBookingTier implements Action {
  readonly type = StoresActionType.AddNewEventBookingTier;
  constructor(
    public readonly storeId: number,
    public readonly source: string,
    public readonly newBookingTier: AddBookingTierRequest,
    public readonly eventId: number,
  ) {}
}
@HideLoader(StoresActionType.AddNewEventBookingTier)
export class AddNewEventBookingTierSuccess implements Action {
  readonly type = StoresActionType.AddNewEventBookingTierSuccess;
  constructor(
    public readonly bookingTier,
    public readonly storeId: number,
    public readonly source: string,
    public readonly eventId: number,
  ) {}
}

@HideLoader(StoresActionType.AddNewEventBookingTier)
export class AddNewEventBookingTierFailed implements Action {
  readonly type = StoresActionType.AddNewEventBookingTierFailed;
  constructor() {}
}
@ShowLoader()
export class GetEvent implements Action {
  readonly type = StoresActionType.GetEvent;
  constructor(
    public readonly storeId: number,
    public readonly eventId: number,
  ) {}
}
@HideLoader(StoresActionType.GetEvent)
export class GetEventSuccess implements Action {
  readonly type = StoresActionType.GetEventSuccess;
  constructor(public readonly eventDetails) {}
}

@HideLoader(StoresActionType.GetEvent)
export class GetEventFailed implements Action {
  readonly type = StoresActionType.GetEventFailed;
  constructor(
    public readonly storeId?: number,
    public readonly eventId?: number,
  ) {}
}

export class ResetEventState implements Action {
  readonly type = StoresActionType.ResetEventState;
  constructor() {}
}

@ShowLoader()
export class UpdateEvent implements Action {
  readonly type = StoresActionType.UpdateEvent;
  constructor(
    public readonly storeId: number,
    public readonly source: string,
    public readonly payload,
    public readonly eventId,
  ) {}
}
@HideLoader(StoresActionType.UpdateEvent)
export class UpdateEventSuccess implements Action {
  readonly type = StoresActionType.UpdateEventSuccess;
  constructor(
    public readonly storeId: number,
    public readonly source,
    public readonly eventDetails,
  ) {}
}

@HideLoader(StoresActionType.UpdateEvent)
export class UpdateEventFailed implements Action {
  readonly type = StoresActionType.UpdateEventFailed;
  constructor() {}
}

@ShowLoader()
export class DeleteEvent implements Action {
  readonly type = StoresActionType.DeleteEvent;
  constructor(
    public readonly storeId: number,
    public readonly source: string,
    public readonly eventId,
    public readonly parentEventId?: number | null,
  ) {}
}
@HideLoader(StoresActionType.DeleteEvent)
export class DeleteEventSuccess implements Action {
  readonly type = StoresActionType.DeleteEventSuccess;
  constructor(
    public readonly storeId: number,
    public readonly source,
    public readonly parentEventId?: number | null,
  ) {}
}

@HideLoader(StoresActionType.DeleteEvent)
export class DeleteEventFailed implements Action {
  readonly type = StoresActionType.DeleteEventFailed;
  constructor() {}
}

@ShowLoader()
export class DeleteBookingTier implements Action {
  readonly type = StoresActionType.DeleteBookingTier;
  constructor(
    public readonly storeId: number,
    public readonly source: string,
    public readonly eventId,
    public readonly bookingId,
  ) {}
}
@HideLoader(StoresActionType.DeleteBookingTier)
export class DeleteBookingTierSuccess implements Action {
  readonly type = StoresActionType.DeleteBookingTierSuccess;
  constructor(
    public readonly storeId: number,
    public readonly source,
    public readonly eventId,
    public readonly bookingId,
  ) {}
}

@HideLoader(StoresActionType.DeleteBookingTier)
export class DeleteBookingTierFailed implements Action {
  readonly type = StoresActionType.DeleteBookingTierFailed;
  constructor() {}
}

@ShowLoader()
export class UpdateBookingTier implements Action {
  readonly type = StoresActionType.UpdateBookingTier;
  constructor(
    public readonly storeId: number,
    public readonly source: string,
    public readonly eventId,
    public readonly bookingId,
    public readonly newBookingTier: AddBookingTierRequest,
  ) {}
}
@HideLoader(StoresActionType.UpdateBookingTier)
export class UpdateBookingTierSuccess implements Action {
  readonly type = StoresActionType.UpdateBookingTierSuccess;
  constructor(
    public readonly storeId: number,
    public readonly source,
    public readonly eventId,
  ) {}
}

@HideLoader(StoresActionType.UpdateBookingTier)
export class UpdateBookingTierFailed implements Action {
  readonly type = StoresActionType.UpdateBookingTierFailed;
  constructor() {}
}

export class EposNowSyncCatalog implements Action {
  readonly type = StoresActionType.EposNowSyncCatalog;
  constructor(public readonly storeId: number) {}
}

export class EposNowSyncCatalogSuccess implements Action {
  readonly type = StoresActionType.EposNowSyncCatalogSuccess;
  constructor(public readonly store: ClientStore) {}
}

export class EposNowSyncCatalogFailed implements Action {
  readonly type = StoresActionType.EposNowSyncCatalogFailed;
  constructor(public readonly errors: any) {}
}

export class SaveZonePosition implements Action {
  readonly type = StoresActionType.SaveZonePosition;
  constructor(
    public readonly zones: SaveZonePositionView,
    public readonly storeId: string,
  ) {}
}

export class SaveZonePositionSuccess implements Action {
  readonly type = StoresActionType.SaveZonePositionSuccess;
  constructor(public readonly zones: SaveZonePositionView) {}
}

export class SaveZonePositionFailed implements Action {
  readonly type = StoresActionType.SaveZonePositionFailed;
  constructor() {}
}

@ShowLoader()
export class UploadStoreVideo implements Action {
  readonly type = StoresActionType.UploadStoreVideo;
  constructor(
    public readonly file: File,
    public readonly uploadFileType: string,
    public readonly storeSetting: string = null,
  ) {}
}

@HideLoader(StoresActionType.UploadStoreVideo)
export class UploadStoreVideoSuccess implements Action {
  readonly type = StoresActionType.UploadStoreVideoSuccess;
  constructor(
    public readonly store: ClientStore,
    public readonly imageUrl: string,
    /**
     * Which store setting the uploaded URL belongs to. The endpoint is generic
     * (`upload-video` carries a `storeSetting` parameter), so the reducer is
     * told where to write, and a brochure upload never touches the kiosk video
     * URL in the admin state. Defaults to the kiosk video, the endpoint's
     * original caller.
     */
    public readonly storeSetting: string = 'INACTIVITY_VIDEO',
  ) {}
}

@HideLoader(StoresActionType.UploadStoreVideo)
export class UploadStoreVideoFailed implements Action {
  readonly type = StoresActionType.UploadStoreVideoFailed;
  constructor(public readonly errorMessages: string[]) {}
}

export class TisslSyncCatalog implements Action {
  readonly type = StoresActionType.TisslSyncCatalog;
  constructor(public readonly storeId: number) {}
}

export class TisslSyncCatalogSuccess implements Action {
  readonly type = StoresActionType.TisslSyncCatalogSuccess;
  constructor(public readonly store: ClientStore) {}
}

export class TisslSyncCatalogFailed implements Action {
  readonly type = StoresActionType.TisslSyncCatalogFailed;
  constructor(public readonly errors: any) {}
}

export class DownloadDailySummaryReport implements Action {
  readonly type = StoresActionType.DownloadDailySummaryReport;
  constructor(
    public readonly storeId: number,
    public readonly referenceDate: string,
  ) {}
}

export class DownloadDailySummaryReportSuccess implements Action {
  readonly type = StoresActionType.DownloadDailySummaryReportSuccess;
  constructor(
    public readonly blob: Blob,
    public readonly filename: string,
  ) {}
}

export class DownloadDailySummaryReportFailed implements Action {
  readonly type = StoresActionType.DownloadDailySummaryReportFailed;
  constructor(public readonly error: string) {}
}

export class PosIntegrationCatalogSync implements Action {
  readonly type = StoresActionType.PosIntegrationCatalogSync;
  constructor(
    public readonly storeId: number,
    public readonly integrationProvider: IntegrationProvider,
  ) {}
}

export class PosIntegrationCatalogSyncSuccess implements Action {
  readonly type = StoresActionType.PosIntegrationCatalogSyncSuccess;
  constructor(public readonly store: ClientStore) {}
}

export class PosIntegrationCatalogSyncFailed implements Action {
  readonly type = StoresActionType.PosIntegrationCatalogSyncFailed;
  constructor(public readonly errors: any) {}
}

export class RegisterRefund implements Action {
  readonly type = StoresActionType.RegisterRefund;
  constructor(
    public readonly storeId: number,
    public readonly payload: any,
  ) {}
}

export class RegisterRefundSuccess implements Action {
  readonly type = StoresActionType.RegisterRefundSuccess;
  constructor(public readonly result: any) {}
}

export class RegisterRefundFailed implements Action {
  readonly type = StoresActionType.RegisterRefundFailed;
  constructor(public readonly errors: string[]) {}
}

export class LoadRefunds implements Action {
  readonly type = StoresActionType.LoadRefunds;
  constructor(
    public readonly storeId: number,
    public readonly paging: Paging,
  ) {}
}

export class LoadRefundsSuccess implements Action {
  readonly type = StoresActionType.LoadRefundsSuccess;
  constructor(
    public readonly refunds: Page<any>,
    public readonly paging: Paging,
  ) {}
}

export class LoadRefundsFailed implements Action {
  readonly type = StoresActionType.LoadRefundsFailed;
  constructor(public readonly error: any) {}
}

export class LoadProducts implements Action {
  readonly type = StoresActionType.LoadProducts;
  constructor(
    public readonly storeId: number,
    public readonly catalogId: number,
  ) {}
}

export class LoadProductsSuccess implements Action {
  readonly type = StoresActionType.LoadProductsSuccess;
  constructor(public readonly products: ProductListResponse[]) {}
}

export class LoadProductsFailed implements Action {
  readonly type = StoresActionType.LoadProductsFailed;
  constructor(public readonly error: string) {}
}

export class GetProduct implements Action {
  readonly type = StoresActionType.GetProduct;
  constructor(
    public readonly storeId: number,
    public readonly catalogId: number,
    public readonly productId: number,
  ) {}
}

export class GetProductSuccess implements Action {
  readonly type = StoresActionType.GetProductSuccess;
  constructor(public readonly product: ProductResponse) {}
}

export class GetProductFailed implements Action {
  readonly type = StoresActionType.GetProductFailed;
  constructor(public readonly error: string) {}
}

export class CreateProduct implements Action {
  readonly type = StoresActionType.CreateProduct;
  constructor(
    public readonly storeId: number,
    public readonly product: any,
    public readonly method?: string,
    public readonly catalogId?: number,
  ) {}
}

export class CreateProductSuccess implements Action {
  readonly type = StoresActionType.CreateProductSuccess;
  constructor(
    public readonly product: ProductResponse,
    public readonly method?: string,
    public readonly storeId?: number,
    public readonly catalogId?: number,
  ) {}
}

export class CreateProductFailed implements Action {
  readonly type = StoresActionType.CreateProductFailed;
  constructor(public readonly error: string) {}
}

export class UpdateProduct implements Action {
  readonly type = StoresActionType.UpdateProduct;
  constructor(
    public readonly storeId: number,
    public readonly productId: number,
    public readonly product: any,
    public readonly method?: string,
    public readonly catalogId?: number,
  ) {}
}

export class UpdateProductSuccess implements Action {
  readonly type = StoresActionType.UpdateProductSuccess;
  constructor(
    public readonly product: ProductResponse,
    public readonly method?: string,
    public readonly storeId?: number,
    public readonly catalogId?: number,
    public readonly productId?: number,
  ) {}
}

export class UpdateProductFailed implements Action {
  readonly type = StoresActionType.UpdateProductFailed;
  constructor(public readonly error: string) {}
}

export class DeleteProduct implements Action {
  readonly type = StoresActionType.DeleteProduct;
  constructor(
    public readonly storeId: number,
    public readonly catalogId: number,
    public readonly productId: number,
  ) {}
}

export class DeleteProductSuccess implements Action {
  readonly type = StoresActionType.DeleteProductSuccess;
  constructor(
    public readonly productId: number,
    public readonly storeId: number,
    public readonly catalogId: number,
  ) {}
}

export class DeleteProductFailed implements Action {
  readonly type = StoresActionType.DeleteProductFailed;
  constructor(public readonly error: string) {}
}

export class LoadPaymentTransactions implements Action {
  readonly type = StoresActionType.LoadPaymentTransactions;
  constructor(
    public readonly storeId: number,
    public readonly paymentStatus: string | null,
    public readonly paging: Paging,
    public readonly dateFrom?: string,
    public readonly dateTo?: string,
  ) {}
}

export class LoadPaymentTransactionsSuccess implements Action {
  readonly type = StoresActionType.LoadPaymentTransactionsSuccess;
  constructor(
    public readonly response: any,
    public readonly paging: Paging,
  ) {}
}

export class LoadPaymentTransactionsFailed implements Action {
  readonly type = StoresActionType.LoadPaymentTransactionsFailed;
  constructor(public readonly error: any) {}
}

export class InviteUserToRegister implements Action {
  readonly type = StoresActionType.InviteUserToRegister;
  constructor(
    public readonly storeId: number,
    public readonly customerId: number,
  ) {}
}

export class InviteUserToRegisterSuccess implements Action {
  readonly type = StoresActionType.InviteUserToRegisterSuccess;
  constructor() {}
}

export class InviteUserToRegisterFailed implements Action {
  readonly type = StoresActionType.InviteUserToRegisterFailed;
  constructor(public readonly error: any) {}
}

export class SetHierarchyType implements Action {
  readonly type = StoresActionType.SetHierarchyType;
  constructor(
    public readonly storeId: number,
    public readonly hierarchyType: 'ORGANIZATION' | 'STORE' | 'NONE',
  ) {}
}

export class SetHierarchyTypeSuccess implements Action {
  readonly type = StoresActionType.SetHierarchyTypeSuccess;
  constructor() {}
}

export class SetHierarchyTypeFailed implements Action {
  readonly type = StoresActionType.SetHierarchyTypeFailed;
  constructor(
    /**
     * Required: the failure effect reloads this store so the dropdown falls back to the stored
     * tier. The optional shape was copied from UpdateStoreSettingsFailed, which has many dispatch
     * sites; this one has exactly one and always knows the id, so making it required stops a
     * future dispatch site silently losing the recovery.
     */
    public readonly storeId: number,
    public readonly error?: string[],
  ) {}
}

export type StoresAction =
  | InitializeState
  | LoadStores
  | LoadStoresPage
  | LoadStoresSuccess
  | LoadStoresFailed
  | LoadStore
  | LoadStoreSuccess
  | LoadStoreFailed
  | CreateStore
  | CreateStoreSuccess
  | CreateStoreFailed
  | PartialUpdateStore
  | PartialUpdateStoreSuccess
  | PartialUpdateStoreFailed
  | DeleteStore
  | DeleteStoreSuccess
  | DeleteStoreFailed
  | DeleteStoreParent
  | DeleteStoreParentSuccess
  | DeleteStoreParentFailed
  | UpdateStore
  | UpdateStoreSuccess
  | UpdateStoreFailed
  | UpdateStoreRelation
  | UpdateStoreRelationSuccess
  | UpdateStoreRelationFailed
  | UpdateStoreSettings
  | UpdateStoreSettingsSuccess
  | UpdateStoreSettingsFailed
  | DownloadQRImage
  | DownloadQRImageSuccess
  | DownloadQRImageFailed
  | DownloadQRPdf
  | DownloadQRPdfSuccess
  | DownloadQRPdfFailed
  | DownloadQRImages
  | DownloadQRImagesSuccess
  | DownloadQRImagesFailed
  | DownloadQRFullPdf
  | DownloadQRFullPdfSuccess
  | DownloadQRFullPdfFailed
  | LoadUsers
  | LoadUsersPage
  | LoadUsersFailed
  | LoadUsersSuccess
  | ChangeAccountManager
  | ChangeAccountManagerSuccess
  | ChangeAccountManagerFailed
  | InviteUser
  | InviteUserSuccess
  | InviteUserFailed
  | RemoveUserStoreAccess
  | RemoveUserStoreAccessSuccess
  | RemoveUserStoreAccessFailed
  | UploadStoreImage
  | UploadStoreImageSuccess
  | UploadStoreImageFailed
  | UploadStoreLogo
  | UploadStoreLogoSuccess
  | UploadStoreLogoFailed
  | SearchStores
  | SearchStoresFailed
  | SearchStoresSuccess
  | LoadStoreStatistics
  | LoadStoreStatisticsFailed
  | LoadStoreStatisticsSuccess
  | LoadMenuViewingStatistics
  | LoadMenuViewingStatisticsFailed
  | LoadMenuViewingStatisticsSuccess
  | LoadLoyaltyStatistics
  | LoadLoyaltyStatisticsFailed
  | LoadLoyaltyStatisticsSuccess
  | ClearLoyaltyStatistics
  | ValidateAliasAvailability
  | ValidateAliasAvailabilitySuccess
  | ValidateAliasAvailabilityFailed
  | ValidateAliasAvailabilityReset
  | ValidateAliasAvailabilityReset
  | LoadNotificationSubscriptionStatus
  | LoadNotificationSubscriptionStatusSuccess
  | LoadNotificationSubscriptionStatusFailed
  | RequestNotificationPermission
  | ToggleNotificationSubscriptionStatus
  | ToggleNotificationSubscriptionStatusSuccess
  | ToggleNotificationPermitted
  | UpdateNotificationSubscriptions
  | LoadAutoprintSubscriptionStatus
  | LoadAutoprintSubscriptionStatusSuccess
  | LoadAutoprintSubscriptionStatusFailed
  | RequestAutoprintPermission
  | ToggleAutoprintSubscriptionStatus
  | ToggleAutoprintSubscriptionStatusSuccess
  | ToggleAutoprintPermitted
  | CreateOrUpdateZone
  | CreateOrUpdateZoneSuccess
  | CreateOrUpdateZoneFailed
  | GetStatusOfZone
  | GetStatusOfZoneSuccess
  | GetStatusOfZoneFailed
  | LoadZones
  | LoadZonesSuccess
  | LoadZonesFailed
  | LoadZone
  | LoadZoneSuccess
  | LoadZoneFailed
  | RemoveZone
  | RemoveZoneSuccess
  | RemoveZoneFailed
  | RemoveStoreLogo
  | RemoveStoreLogoFailed
  | RemoveStoreImage
  | RemoveStoreLogoSuccess
  | RemoveStoreImageSuccess
  | RemoveStoreImageFailed
  | RemoveStoreHeaderVideo
  | RemoveStoreHeaderVideoSuccess
  | RemoveStoreHeaderVideoFailed
  | CheckStoreHasNewOrder
  | CheckStoreHasNewOrderSuccess
  | CheckStoreHasNewOrderFailed
  | StartOrderNotificationSound
  | DownloadOrderItemsXls
  | DownloadOrderItemsXlsFailed
  | DownloadOrderItemsXlsSuccess
  | InitializeStoreUserExperience
  | UpdateStoreTabUserExperience
  | UpdateStoreTab
  | UpdateStoreZoneSettings
  | UpdateStoreZoneSettingsSuccess
  | UpdateStoreZoneSettingsFailed
  | UpdateStoreVatPercentage
  | UpdateStoreVatPercentageSuccess
  | UpdateStoreVatPercentageFailed
  | MynextLogin
  | MynextLoginSuccess
  | MynextLoginFailed
  | ClearStoreValidation
  | HubriseLogin
  | HubriseLoginSuccess
  | HubriseLoginFailed
  | HubriseLogout
  | HubriseLogoutSuccess
  | HubriseLogoutFailed
  | ClearHubriseData
  | LoadCustomersPage
  | LoadCustomersSuccess
  | LoadCustomersFailed
  | TopOrderCustomersPage
  | TopOrderCustomersSuccess
  | TopOrderCustomersFailed
  | TopReservationCustomersPage
  | TopReservationCustomersSuccess
  | TopReservationCustomersFailed
  | DownloadCustomersList
  | DownloadCustomersListSuccess
  | DownloadCustomersListFailed
  | LoadOrderItemsStatisticsSuccess
  | LoadOrderItemsStatisticsFailed
  | LoadOrderItemsStatisticsPage
  | DownloadFlyerFile
  | DownloadFlyerFileSuccess
  | DownloadFlyerFileFailed
  | PowersoftLogin
  | PowersoftLoginSuccess
  | PowersoftLoginFailed
  | DisconnectPowersoft
  | DisconnectPowersoftSuccess
  | DisconnectPowersoftFailed
  | WoltLogin
  | WoltLoginSuccess
  | WoltLoginFailed
  | DisconnectWolt
  | DisconnectWoltSuccess
  | DisconnectWoltFailed
  | DisconnectMyNext
  | DisconnectMyNextSuccess
  | DisconnectMyNextFailed
  | SyncWoltCatalog
  | SyncWoltCatalogSuccess
  | SyncWoltCatalogFailed
  | CustomEndPointValidate
  | CustomEndPointValidateSuccess
  | CustomEndPointValidateFailed
  | LoadCustomer
  | LoadCustomerSuccess
  | LoadCustomerFailed
  | LoadBasicCustomer
  | LoadBasicCustomerSuccess
  | LoadBasicCustomerFailed
  | LoadCustomerOrderSummary
  | LoadCustomerOrderSummarySuccess
  | LoadCustomerOrderSummaryFailed
  | LoadCustomerReservationStatistics
  | LoadCustomerReservationStatisticsSuccess
  | LoadCustomerReservationStatisticsFailed
  | LoadCustomerLoyaltyProfile
  | LoadCustomerLoyaltyProfileSuccess
  | LoadCustomerLoyaltyProfileFailed
  | LoadCustomerOrderItemsStatistics
  | LoadCustomerOrderItemsStatisticsSuccess
  | LoadCustomerOrderItemsStatisticsFailed
  | LoadCustomerReset
  | SaveCustomerForm
  | SaveCustomerFormSuccess
  | SaveCustomerFormFailed
  | LoadCustomerRecentOrders
  | LoadCustomerRecentOrdersSuccess
  | LoadCustomerRecentOrdersFailed
  | LoadCustomerLoyaltyTrasactions
  | LoadCustomerLoyaltyTrasactionsSuccess
  | LoadCustomerLoyaltyTrasactionsFailed
  | LoadCustomerOrderItems
  | LoadCustomerOrderItemsSuccess
  | LoadCustomerOrderItemsFailed
  | LoadCustomerReservationList
  | LoadCustomerReservationListSuccess
  | LoadCustomerReservationListFailed
  | AddNewEventBookingTier
  | AddNewEventBookingTierSuccess
  | AddNewEventBookingTierFailed
  | GetEvent
  | GetEventSuccess
  | GetEventFailed
  | ResetEventState
  | UpdateEvent
  | UpdateEventSuccess
  | UpdateEventFailed
  | DeleteEvent
  | DeleteEventSuccess
  | DeleteEventFailed
  | DeleteBookingTier
  | DeleteBookingTierSuccess
  | DeleteBookingTierFailed
  | UpdateBookingTier
  | UpdateBookingTierSuccess
  | UpdateBookingTierFailed
  | LoadCustomerEventBookingsStatistics
  | LoadCustomerEventBookingsStatisticsSuccess
  | LoadCustomerEventBookingsStatisticsFailed
  | EposNowSyncCatalog
  | EposNowSyncCatalogSuccess
  | EposNowSyncCatalogFailed
  | SaveZonePosition
  | SaveZonePositionSuccess
  | SaveZonePositionFailed
  | UploadStoreVideo
  | UploadStoreVideoSuccess
  | UploadStoreVideoFailed
  | TisslSyncCatalog
  | TisslSyncCatalogSuccess
  | TisslSyncCatalogFailed
  | DownloadDailySummaryReport
  | DownloadDailySummaryReportSuccess
  | DownloadDailySummaryReportFailed
  | PosIntegrationCatalogSync
  | PosIntegrationCatalogSyncSuccess
  | PosIntegrationCatalogSyncFailed
  | RegisterRefund
  | RegisterRefundSuccess
  | RegisterRefundFailed
  | LoadRefunds
  | LoadRefundsSuccess
  | LoadRefundsFailed
  | LoadPaymentTransactions
  | LoadPaymentTransactionsSuccess
  | LoadPaymentTransactionsFailed
  | LoadProducts
  | LoadProductsSuccess
  | LoadProductsFailed
  | GetProduct
  | GetProductSuccess
  | GetProductFailed
  | CreateProduct
  | CreateProductSuccess
  | CreateProductFailed
  | UpdateProduct
  | UpdateProductSuccess
  | UpdateProductFailed
  | DeleteProduct
  | DeleteProductSuccess
  | DeleteProductFailed
  | InviteUserToRegister
  | InviteUserToRegisterSuccess
  | InviteUserToRegisterFailed
  | SetHierarchyType
  | SetHierarchyTypeSuccess
  | SetHierarchyTypeFailed;
